import type { ProjectResponse } from '@contract-analyzer/api-client';
import { createContext } from 'react';

export interface ProjectContext {
  readonly project: ProjectResponse;
  readonly updateProject?: (project: ProjectResponse) => void;
}

export const ProjectCtx = createContext<ProjectContext | null>(null);
